import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import HeaderSection from "./HeaderSection";
import PlayGroundTabs from "./components/PlayGroundTabs";
import group1 from "../../images/Group (1).png";
import group2 from "../../images/Group (2).png";

const Index = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="flex flex-col min-h-screen w-full relative bg-[#f5faf5]">
      {/* Background Decorative Images */}
      <img
        src={group2}
        alt="Right Design"
        className="absolute right-0 top-[28rem] w-16 md:w-24 opacity-90 z-0 pointer-events-none"
      />
      <img
        src={group1}
        alt="Left Design"
        className="absolute left-0 bottom-0 w-16 md:w-24 opacity-90 z-0 pointer-events-none"
      />

      {/* Header Section */}
      <div className="flex-grow z-10" data-aos="fade-down">
        <HeaderSection
          title="See NKENNEAi At Work"
          description="Test our translation and speech tools firsthand and see how NKENNEAi brings languages to life with real-time demos."
          playgroundText="PLAYGROUND"
        />
      </div>

      {/* Welcome Section */}
      <div className="flex flex-col items-center gap-8 mb-8 z-10" data-aos="fade-up">
        <div className="flex flex-col items-center gap-2">
          <h3 className="text-[#ef8702] text-base font-bold tracking-wide uppercase">
            LET's GET YOU STARTED
          </h3>
          <h1 className="text-5xl font-bold text-center">
            Welcome To NKENNEAi Playground
          </h1>
          <p className="text-base text-center max-w-[576px]">
            Explore our live demos and interact with our translation and speech features.
          </p>
        </div>
      </div>

      {/* Tabs / Conversion Area */}
      <div className="w-full z-10" data-aos="zoom-in">
        <PlayGroundTabs />
      </div>
    </div>
  );
};

export default Index;
